import { getRegionalisedQrCodeLink } from 'approot/shared/logic/get-regionalised-qr-code-link';
import { ViewProps } from './interactive.constants';
import { PrintStimulusAspectRatio } from '../print/print-stimulus';
import { CommonPrintProps } from 'approot/activity-builder/activity-builder.constants';
import { getPrintImage } from '../shared/logic/get-print-image';

const InteractivePrint = (
  props: ViewProps &
    CommonPrintProps & { contentVersion: string | null | undefined }
) => {
  const stimulus = props.stimulusResourceProperties;
  return stimulus?.link ? (
    <PrintStimulusAspectRatio
      isPrintPreview={props.isPrintPreview}
      dimensions={props.properties.dimensionData}
      coverImage={
        stimulus.xlCoverImageUrls?.length
          ? getPrintImage(stimulus.xlCoverImageUrls || null)
          : stimulus.coverImage?.original
      }
      link={getRegionalisedQrCodeLink(
        stimulus.slug || '',
        props.contentVersion
      )}
    />
  ) : null;
};

export default InteractivePrint;
